// extracted by mini-css-extract-plugin
export default {"wrapper":"TicketFloatPopup_wrapper__tf3hd","notice":"TicketFloatPopup_notice__BUeGo"};